(() => {
  const header = document.querySelector("[data-vv-header]");
  if (!header) return;

  // Sticky blur-on-scroll
  const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 6);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // ---- Desktop dropdowns (hover + click + outside + ESC) ----
  const items = header.querySelectorAll("[data-vv-item][data-has-dropdown='true']");
  let openItem = null;

  const closeAll = () => {
    items.forEach((i) => {
      i.dataset.open = "false";
      const trigger = i.querySelector("[data-vv-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
    openItem = null;
  };

  const open = (item) => {
    if (openItem && openItem !== item) {
      openItem.dataset.open = "false";
      const oldTrigger = openItem.querySelector("[data-vv-trigger]");
      if (oldTrigger) oldTrigger.setAttribute("aria-expanded", "false");
    }
    item.dataset.open = "true";
    const trigger = item.querySelector("[data-vv-trigger]");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    openItem = item;
  };

  items.forEach((item) => {
    const trigger = item.querySelector("[data-vv-trigger]");
    const dropdown = item.querySelector("[data-vv-dropdown]");
    if (!trigger || !dropdown) return;

    // Hover
    item.addEventListener("mouseenter", () => open(item));
    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!item.matches(":hover")) {
          item.dataset.open = "false";
          trigger.setAttribute("aria-expanded", "false");
          if (openItem === item) openItem = null;
        }
      }, 80);
    });

    // Click toggles dropdown (prevents navigation when dropdown exists)
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = item.dataset.open === "true";
      if (isOpen) {
        item.dataset.open = "false";
        trigger.setAttribute("aria-expanded", "false");
        if (openItem === item) openItem = null;
      } else {
        open(item);
      }
    });

    // Keyboard
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const isOpen = item.dataset.open === "true";
        if (isOpen) closeAll();
        else open(item);
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (!header.contains(e.target)) closeAll();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // ---- Mobile drawer ----
  const drawer = header.querySelector("[data-vv-drawer]");
  const openBtn = header.querySelector("[data-vv-drawer-open]");
  const closeBtns = header.querySelectorAll("[data-vv-drawer-close]");

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  };

  if (openBtn) openBtn.addEventListener("click", openDrawer);
  closeBtns.forEach((btn) => btn.addEventListener("click", closeDrawer));

  // Mobile accordion
  header.querySelectorAll("[data-vv-mitem]").forEach((item) => {
    const toggle = item.querySelector("[data-vv-mtoggle]");
    if (!toggle) return;
    toggle.addEventListener("click", () => {
      const isOpen = item.dataset.open === "true";
      item.dataset.open = isOpen ? "false" : "true";
      toggle.textContent = isOpen ? "+" : "–";
    });
  });

  // ---- Theme toggle (optional) ----
  const themeBtn = header.querySelector("[data-vv-theme-toggle]");
  const KEY = "vv_theme";

  const applyTheme = (t) => {
    if (t === "dark") document.documentElement.classList.add("vv-dark");
    else document.documentElement.classList.remove("vv-dark");
  };

  try {
    const saved = localStorage.getItem(KEY);
    if (saved) applyTheme(saved);
  } catch (_) {}

  if (themeBtn) {
    themeBtn.addEventListener("click", () => {
      const isDark = document.documentElement.classList.contains("vv-dark");
      const next = isDark ? "light" : "dark";
      applyTheme(next);
      try { localStorage.setItem(KEY, next); } catch (_) {}
    });
  }

  // ---- Mobile swipe icon nav -> open drawer + auto-expand matching menu ----
  const cssEscape = (str) => {
    // Fallback if CSS.escape isn't available
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(str);
    return String(str).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  };

  const mobileIcons = header.querySelectorAll("[data-vv-mobileicon]");
  mobileIcons.forEach((a) => {
    a.addEventListener("click", (e) => {
      const key = (a.getAttribute("data-key") || "").toLowerCase().trim();
      const hasDropdown = a.getAttribute("data-has-dropdown") === "true";

      if (hasDropdown) {
        e.preventDefault();
        openDrawer();

        const selector = `[data-vv-mitem][data-key="${cssEscape(key)}"]`;
        const target = header.querySelector(selector);

        if (target) {
          target.dataset.open = "true";
          const tgl = target.querySelector("[data-vv-mtoggle]");
          if (tgl) tgl.textContent = "–";

          setTimeout(() => {
            try { target.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (_) {}
          }, 80);
        }
      }
      // If no dropdown, it navigates normally.
    });
  });
  // Keep wheel scrolling inside mobile icon track only
  const track = header.querySelector("[data-vv-micontrack]");
    if (track) {
      track.addEventListener("wheel", (e) => {
       if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // already horizontal
      // convert vertical wheel to horizontal scroll inside track
      e.preventDefault();
      track.scrollLeft += e.deltaY;
  }, { passive: false });
}
})();